import React, { useCallback, useEffect, useState } from "react";
import { getSocialLinks } from "../../services/homeRequestServices";
import styled from "styled-components";
import linkedin from "../../assets/media/linkedin.png";
import aparat from "../../assets/media/aparat.png";
import instagram from "../../assets/media/instagram.png";
import whatsapp from "../../assets/media/whatsapp.png";
import variables from "../../assets/js/variables";

const { colors } = variables;

function Container({ href, title, img }) {
  return (
    <div className="container-social">
      <a href={href} alt="" target="_blank" rel="noreferrer">
        <img src={img} alt="" />
        <h4>{title}</h4>
      </a>
    </div>
  );
}

function Sochial(props) {
  const { header } = props;
  const [socialLinksData, changeSocialLinksData] = useState([]);

  const getSocialLinksData = useCallback(() => {
    return getSocialLinks().then((res) => changeSocialLinksData(res.results));
  }, []);

  useEffect(() => {
    getSocialLinksData();
  }, [getSocialLinksData]);

  return (
    <Styles
      className={
        "row mx-0 border border-1 border-blue rounded p-3 p-md-4 text-14"
      }
    >
      <p className="header-contact-sochial">{header}</p>
      {socialLinksData.map((i, index) => {
        if (
          i.title === "instagram" ||
          i.title === "linkedin" ||
          i.title === "whatsapp" ||
          i.title === "aparat"
        ) {
          return (
            <Container
              key={index + i.url}
              img={
                i.title === "instagram"
                  ? instagram
                  : i.title === "linkedin"
                  ? linkedin
                  : i.title === "whatsapp"
                  ? whatsapp
                  : i.title === "aparat"
                  ? aparat
                  : ""
              }
              title={
                i.title === "instagram"
                  ? "اینستاگرام"
                  : i.title === "linkedin"
                  ? "لینکدین"
                  : i.title === "whatsapp"
                  ? "واتساپ"
                  : i.title === "aparat"
                  ? "آپارات"
                  : ""
              }
              href={i.url}
            />
          );
        } else {
          return null;
        }
      })}
    </Styles>
  );
}

export default Sochial;
const Styles = styled.span`
  display: flex;

  .container-social {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 25%;
    height: 100%;
    flex-wrap: wrap;
    a {
      text-decoration: none;
      font-size: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      cursor: pointer;
      width: fit-content;
      height: fit-content;
    }
    h4 {
      color: ${colors.green};
    }
    img {
      width: 90%;
      border-radius: 50%;
      margin-bottom: 10px;
    }
  }

  @media (max-width: 600px) {
    .container-social {
      padding: 5px;
      width: 50%;
      padding: 0 !important;
      margin: 10px 0;
      img {
        width: 50%;
      }
      a {
        font-size: 14px;
      }
      h4 {
        font-size: 14px;
      }
    }
  }

  .header-contact-sochial {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: 0 !important;
    margin-bottom: 1rem !important;
    font-size: 18px;
    @media (max-width: 600px) {
      font-size: 12px;
    }
  }
`;
